module.exports = __webpack_public_path__ + "b8ff0fa6245a2a1ed95c46d807978f1b.jpg";